import { queryOrgList } from 'liyu-pc-base/api/sys';
import { useUserStore } from 'liyu-pc-base/init-plugin';

export default () => {
  const userStore = useUserStore();
  const current_org = userStore.currentOrg;
  const search_config: any = {
    model: {
      org_id: current_org?.id,
      aim_org_id: current_org?.id,
      is_active: true,
    },
  };
  return {
    getData: queryOrgList,
    searchConfig: search_config,
  };
};
